import { Container, Row, Col } from "react-bootstrap";

const Header = ({
  title,
  titleEmpty,
  text,
  btnText,
  imgBig,
  imgSmall,
  isEmpty,
  setIsModal,
}) => {
  return (
    <Container>
      <Row>
        <Col
          sm={12}
          lg={6}
          className="d-flex align-items-center justify-content-center   text-center mx-auto"
        >
          <div>
            <div className={`mb-5 ${isEmpty ? "" : "d-none"}`}>
              <img
                src={imgBig}
                alt="hero big"
                className="d-none d-lg-table mx-auto"
              />
              <img
                src={imgSmall}
                alt="hero small"
                className="d-lg-none mx-auto"
              />
            </div>
            <h2>{isEmpty ? titleEmpty : title}</h2>
            <p>{text}</p>
            <button
              className={`btn btn-primary text-md btn-block btn-full mt-4 ${
                isEmpty ? "" : "d-none"
              }`}
              onClick={() => setIsModal(true)}
            >
              <i className="bi bi-plus"></i> {btnText}
            </button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default Header;
